/* globals $, tfl_validate, grecaptcha, intlTelInputUtils */
import "regenerator-runtime"; // Required for Address Verification
import Verify_Addresses from "./libraries/address_verification.js";
//import { displayErrorNotification, displaySuccessNotification } from "./libraries/notifications.js";
//import state_dropdown_swap from "exports-loader?state_dropdown_swap!../js/responsive/state_dropdown_swap";
var TFL_donate = window.TFL_donate || {};

Promise.all([
  import(/* webpackChunkName: "qas" */ "./loaders/qas-loader"),
  import(/* webpackChunkName: "validation" */ "./loaders/validation-loader"),
  import(/* webpackChunkName: "intlTelInput" */ "./loaders/intlTelInput-loader")
]).then(() => {
  setup();
  document.addEventListener("remount:donate-web", remount);
});

function remount() {
    set_amount_buttons();
    qasvalidation_setup();
    monthly_toggle();
    nonqasvalidation_setup();
    payment_setup();
    payment_validation_setup();
    payment_validation();
    reveal_payment_iframe();
    setupResourceRadioButtons();
    setUpGiftEffects();
    donationPaymentOptions();
    shipping_address_change_link();
    setup_saved_payments();
    setup_tp_spouse();
    scrollOnLoad();
}

function setup() {
  remount();
}

// Run on Rendered
function scrollOnLoad() {
    $(window).bind("load", function() {
        jump_to_it();
    });
}


// Jump to review point
function jump_to_it() {
  if ($('.jumpto:visible').length > 0) {
    scrollToIt($('.jumpto:visible').first().offset());
    set_resource_choice();
  }
}

// Amount buttons set on type and update on click
function set_amount_buttons() {
  // Set Amount to button pressed.
  $('a.amount-btn').click(
      function() {
          var myform = $(this).closest('form');
          myform.find('.amount-btn').not(this).removeClass("selected");
          var amount_input = myform.find('.gift-amount');
          $(this).toggleClass("selected");
          if ($(this).hasClass('selected')) {
              amount_input.val($(this).data('value').toString());
          }
          else {
              amount_input.val('');
          }
          amount_input.trigger('input');
          return false;
      }
  );
  var previousValue = 0;
  $('.gift-amount').on('click init', function() {
      var currentValue = $(this).val();
      if (currentValue != previousValue) {
          previousValue = currentValue;
          $(this).parents('form').find('.amount-btn').each(function() {
              if ($(this).data('value').toString() === currentValue) {
                  $(this).addClass('selected');
              }
              else {
                  $(this).removeClass('selected');
              }
          });
      }
  }).trigger('init');
}

function _conditionallyEnableMonthly() {
  // Monthly giving isn't a binary toggle. Enable the Monthly Giving checkbox when the following conditions
  // are met:
  // 1. Payment method is credit card.
  // 2. Resource is not being sent as a gift.
  let wantsResource = $(".wants_donation_product.not-monthly:checked");
  if ($('#givingform').hasClass("payment-cc") && wantsResource.val() !== "2") {
    let monthlyCheckbox = $(".js-give_monthly");
    monthlyCheckbox.prop("disabled", false);
    monthlyCheckbox.parent("label").removeClass("muted-text");
  }
}

function donationPaymentOptions() {
    $('.payment-type').on('click', '.payment-type__wrapper:not(.disabled)', function() {
        if (!$(this).hasClass('active')) {
            $(".payment-type__wrapper").removeClass('active');
            $(this).addClass('active');

            var input = $(this).find('.payment-type__input');
            input.prop("checked", true);
            $('#givingform').attr('action', input.data('formaction'));
            $('#givingform').removeClass(function (index, className) { return (className.match(/(^|\s)payment-\w+/g) || []).join(' ');});
            $('#givingform').addClass(input.data('formclass'));

            $('.payment-type__input').not(this).prop("checked", false);
            $('.payment-type__label').not(this).removeClass('btn-primary');
            $(this).find('.payment-type__label').addClass('btn-primary');
            payment_validation();

            // Disable monthly giving for paypal
            if (input.val() == 'paypal') {
                if ($(".js-give_monthly").is(":checked")) {
                    $(".js-give_monthly").click();
                }
                $(".js-give_monthly").prop("disabled", true);
                $(".js-give_monthly__wrapper").addClass("disabled");
            }
            // Enable monthly giving for CC.
            else {
                _conditionallyEnableMonthly();
            }

            if (input.val() == 'cc') {
              if (!$("#payment_iframe").length > 0)
                qasvalidation_setup();
            }
        }
    });
}

function setup_tp_spouse() {
    $('#givingform').on('click', '.js-add_spouse', function(ev) {
        if ($(ev.target).is(":checked")) {
            $(".js-spouse_last_name").attr('placeholder', $(".js-last_name").val());
            $("#id_add_spouse").slideDown(300);
        } else {
            $("#id_add_spouse").slideUp("fast");
        }
    });
    $('#givingform').on('change', '.js-last_name', function() {
        $(".js-spouse_last_name").attr('placeholder', $(".js-last_name").val());
    });
}

function reveal_payment_iframe() {
  $('.reveal-iframe').click(
    function() {
        var myform = $(this).closest('form');
        myform.find('.cc_container').slideDown(300, function() {
          myform.find('.payment-encoded').slideUp("fast");
          $('#cc_token_val').val("");
          $('#cc_token_id').val("");
        });
    }
  );
}

function shipping_address_change_link() {
  $('#givingform').on('click', '.shipping_address_change_link', function() {
    $('#copy_address').attr('checked', false).change();
  });
}

function monthly_toggle() {
  $('#givingform').on('change', '.js-give_monthly', function() {
    if ($(this).is(":checked")) {
        $('.payment-type__wrapper.paypal, .payment-type__wrapper.paypal .btn').addClass("disabled").attr('title', 'Monthly giving is not currently available using PayPal');
        $('#givingform').addClass('payment-monthly');
    }
    else {
        $('.payment-type__wrapper.paypal, .payment-type__wrapper.paypal .btn').removeClass("disabled").attr('title', "");
        $('#givingform').removeClass('payment-monthly');
    }
    // Reset Form Validation
    reset_donation_product();
    payment_validation();

  });
}

function setup_saved_payments() {
  $('body').on("click", '.js-saved_payment_option', function() {
    $("#saved_payment_id").val($(this).attr("data-payment-id"));
    var radio = $(this).find(".saved_payment_id_option:first");
    if (radio.prop("checked") != "checked") {
      $('.saved_payment_id_option:checked').prop("checked", false);
      $('.payment_method.radio').removeClass("active");
      $(this).find(".saved_payment_id_option:first").prop("checked", true);
      $(this).find(".payment_method.radio").addClass("active");
      if ($(this).attr("data-payment-id") == "NEW") {
        $("#new_card__wrapper").show();
      } else {
        $("#new_card__wrapper").hide();
      }
    }
  });

  $('body').on("click", '#payment_change_link', function() {
    $("#saved_payment_id").val("");
  });

  if ($('.saved_payment_id_option:checked').val() == 'NEW') {
    $('.saved_payment_id_option:checked').click();
  }

}

function reset_donation_product() {
  $('.wants_donation_product').prop('checked', false);
  $('.Resources .available-formats').hide();
}

function nonqasvalidation_setup() {
    $('.noqas').on('click', function(ev) {
        $(this).prop('disabled', true);
        ev.preventDefault();
        var form = $(ev.currentTarget).closest('form');
        fixBlank(form);
        var btn = $(form).find('.btn-primary-call');
        if (form.valid()) {
            btn.prop('disabled', true);
            form.submit();
        }
        else {
          btn.prop('disabled', false);
        }
    });
}

function qasvalidation_setup() {
    var config = {
        // QAS Handling for Email Addresses
        EMAIL: {          
            EMAIL_FIELD_IDS: ["email", ],
        },
        ADDRESS_FIELDS: [
            {
            address_1: "#address_1",
            address_2: "#address_2",
            address_3: "#address_3",
            address_4: "#address_4",
            city: "#city",
            state: "#choice_state",
            postal_code: "#zip",
            country: "#country",
            address_verified: "#address_validated",
            },
            {
            address_1: "#shipping_address_1",
            address_2: "#shipping_address_2",
            address_3: "#shipping_address_3",
            address_4: "#shipping_address_4",
            city: "#shipping_city",
            state: "#choice_ship_state",
            postal_code: "#shipping_zip",
            country: "#shipping_country",
            address_verified: "#shipping_address_validated",
            }
        ]
    };

    $('.qas-validate').on('click', function(ev) {
        ev.preventDefault();
        var form = $(ev.currentTarget).closest('form');
        fixBlank(form);

        if (form.valid()) {
            var btn = $(form).find('.btn-primary-call');
            btn.prop('disabled', true);

            // Recaptcha Functionality
            grecaptcha.ready(function() {
                var recaptcha_id = form.find('.recaptcha_widget');
                var recaptcha = recaptcha_id.first();
                var sitekey = recaptcha.data('sitekey');
                grecaptcha.execute(sitekey, {action: 'submit_donation'}).then(function(token) {
                    document.getElementById('g-recaptcha-response').value = token;
                    return Verify_Addresses(form, config);
                });
            });
        }
    });

    $('.noqascc').on('click', function(ev) {
        $(this).prop('disabled', true);
        ev.preventDefault();
        var form = $(ev.currentTarget).closest('form');
        var btn = $(form).find('.btn-primary-call');
        fixBlank(form);

        if (form.valid()) {
            btn.prop('disabled', true);

            // Recaptcha Functionality
            grecaptcha.ready(function() {
                var recaptcha_id = form.find('.recaptcha_widget');
                var recaptcha = recaptcha_id.first();
                var sitekey = recaptcha.data('sitekey');
                grecaptcha.execute(sitekey, {action: 'submit_donation'}).then(function(token) {
                  document.getElementById('g-recaptcha-response').value = token;
                  form.submit();
                });
              });
        }
        else {
            btn.prop('disabled', false);
        }

    });

}

function payment_setup() {
    // Setup Tasks
    enable_submit();
    copy_address_setup();
    phone_input_setup();
    country_state_setup();
}

function enable_submit() {
    $('.donate-jsform').removeClass('hidden');
    $('button.qas-validate').prop('disabled', false);
}

function isCCTokenRequired() {
  var saved_payment_id = $("#saved_payment_id").val();
  if (saved_payment_id && saved_payment_id != 'NEW') {
    return false;
  }
  return true;
}

function isSavedPaymentRequired() {
  if ($("#saved_payment_id").length > 0) {
    return true;
  }
  return false;
}

function isStateZipRequired(elem) {
    var $form = $(elem).closest('.form-section');
    return $.inArray(
            $form.find('.country_picker').val(),
                ['CA','US']
                ) !== -1;
}

function isShippingRequired(elem) {
    var $copy_address = $(elem).closest('form').find("input[name='copy_address']");
    return (!($copy_address.is(":checked")));
}

function isSpouseFirstNameRequired(elem) {
    var $add_spouse = $(elem).closest('form').find("input[name='add_spouse']");
    return ($add_spouse.is(":checked"));
}

function isOneTime(elem) {
    var $recurrence = $(elem).closest('form').find("input[name='recurrence']");
    return ($recurrence.val() != 'monthly');
}

function fixBlank(form) {
  form.find('input').each(function() {
      $(this).val($(this).val().trim());
      // Check that only one resource format is set
      if ($(this).attr("name") == 'donation_product_format') {
        if (!$(this).closest('.form-group').is(":visible")) {
          $(this).attr("checked", false);
        }
      }

  });
}

function set_resource_choice() {
  $("#givingform").find("input[name=wants_donation_product]").each(function() {
    if ($(this).attr("checked") == "checked") {
      if ($(this).closest('.form-group').is(":visible")) {
        $(this).trigger("click");
      }
    }
  });
}

function payment_validation_setup() {
     TFL_donate.paypal_validation = {
        ignore: '.is-cc',
        onsubmit: true,
        focusInvalid: true,
        errorPlacement: function(error, el) {
            if ($.inArray(el.attr("name"), ['gift_amount']) !== -1) {
                el.parent().after(error);
            }
            else if ($.inArray($(el).attr("name"), ['wants_donation_product']) !== -1) {
                el.closest('.vflag-container').after(error);
            }
            else {
                error.insertAfter(el);
            }
        },
        errorElement: "div",
        errorClass: "alert alert-danger",
        highlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').addClass('has-error').removeClass(validClass);
        },
        unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').removeClass('has-error').addClass(validClass);
        },
        rules : {
            "gift_amount" : {
                required: true,
                min: '1',
                currency: true
            },
            "radio_station_mediaid" : {
                required: true,
                minlength: '2'
            },
            "wants_donation_product": {
              required: true,
            },
        },
        messages : {
            "radio_station_mediaid" : {
                required: "This is required. If you listen on the radio and you don't see any stations listed above, click 'Find Your Station' to search for a station."
            },
        },
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
            return;

            scrollToIt($(validator.errorList[0].element).offset());
        },
        submitHandler: function(form) {
            $(form).find('.btn-primary-call').text('Processing...').prop('disabled', true);

            // Recaptcha Functionality
            grecaptcha.ready(function() {
                var recaptcha_id = $(form).find('.recaptcha_widget');
                var recaptcha = recaptcha_id.first();
                var sitekey = recaptcha.data('sitekey');
                grecaptcha.execute(sitekey, {action: 'store_saved_payment'}).then(function(token) {
                  document.getElementById('g-recaptcha-response').value = token;
                  form.submit();
                });
            });
        }
    };

    TFL_donate.cc_validation = {
        ignore: ".is-monthly",
        onsubmit: false,
        focusInvalid: true,
        errorPlacement: function(error, el) {
            if ($.inArray(el.attr("name"), ['phone', 'gift_amount']) !== -1) {
                el.parent().after(error);
            }
            else if ($.inArray($(el).attr("name"), ['wants_donation_product']) !== -1) {
                el.closest('.vflag-container').after(error);
            }
            else if ($.inArray($(el).attr("name"), ['cc_token_val']) !== -1) {
                el.closest('.cc_container').find('.cc_errors').before(error);
            }
            else if ($.inArray($(el).attr("name"), ['email']) !== -1) {
                el.closest('.vflag').removeClass("form-hidden");
                error.insertAfter(el);
            }
            else {
                error.insertAfter(el);
            }
        },
        errorElement: "div",
        errorClass: "alert alert-danger",
        highlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').addClass('has-error').removeClass(validClass);
        },
        unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').removeClass('has-error').addClass(validClass);
        },
        rules : {
            "cc_token_val" : {
                required: isCCTokenRequired,
            },
            "saved_payment_id" : {
                required: isSavedPaymentRequired,
            },
            "gift_amount" : {
                required: true,
                min: '1',
                currency: true
            },
            "phone" : {
                minlength: '3'
            },
            "email" : {
                email: true
            },
            "shipping_first_name" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isOneTime(element));
                    }
                }
            },
            "shipping_last_name" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isOneTime(element));
                    }
                }
            },
            "choice_state" : {
                required: isStateZipRequired
            },
            "zip" : {
                required: isStateZipRequired
            },
            "shipping_address_1" : {
                required: isShippingRequired,
            },
            "shipping_city" : {
                required: isShippingRequired,
            },
            "shipping_country" : {
                required: isShippingRequired,
            },
            "choice_ship_state" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isStateZipRequired(element));
                    }
                }
            },
            "shipping_zip" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isStateZipRequired(element));
                    }
                }
            },
            "radio_station_mediaid" : {
                required: true,
                minlength: '2'
            },
            "wants_donation_product": {
              required: true,
            },
        },
        messages : {
            "phone" : {
                minlength: "Please enter a valid phone number."
            },
            "cc_token_val": {
                required: "<b>Your payment information contains the following errors:</b>"
            },
            "saved_payment_id": {
                required: "Please select a payment method."
            },
            "radio_station_mediaid" : {
                required: "This is required. If you listen on the radio and you don't see any stations listed above, click 'Find Your Station' to search for a station."
            },
        },
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids()) {
                return;
            }
            if ($(validator.errorList[0].element).attr('name') == 'cc_token_val') {
                var destination = $(validator.errorList[0].element).closest('form').find('.clover_wrapper');
                if (destination) {
                  scrollToIt(destination.offset());
                }
            }
            else {
                scrollToIt($(validator.errorList[0].element).offset());
            }
        },
    };

    TFL_donate.monthly_validation = {
        ignore: ".not-monthly",
        onsubmit: false,
        focusInvalid: true,
        errorPlacement: function(error, el) {
            if ($.inArray(el.attr("name"), ['phone', 'gift_amount']) !== -1) {
                el.parent().after(error);
            }
            else if ($.inArray($(el).attr("name"), ['wants_donation_product', 'recurrence_day']) !== -1) {
                el.closest('.vflag-container').after(error);
            }
            else if ($.inArray($(el).attr("name"), ['cc_token_val']) !== -1) {
                el.closest('.cc_container').find('.cc_errors').before(error);
            }
            else if ($.inArray($(el).attr("name"), ['email']) !== -1) {
                el.closest('.vflag').removeClass("form-hidden");
                error.insertAfter(el);
            }
            else {
                error.insertAfter(el);
            }
        },
        errorElement: "div",
        errorClass: "alert alert-danger",
        highlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').addClass('has-error').removeClass(validClass);
        },
        unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.vflag').removeClass('has-error').addClass(validClass);
        },
        rules : {
            "cc_token_val" : {
                required: isCCTokenRequired,
            },
            "saved_payment_id" : {
                required: isSavedPaymentRequired,
            },
            "spouse_first_name": {
                required: isSpouseFirstNameRequired,
            },
            "gift_amount" : {
                required: true,
                min: '1',
                currency: true
            },
            "phone" : {
                minlength: '3'
            },
            "email" : {
                email: true
            },
            "shipping_first_name" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isOneTime(element));
                    }
                }
            },
            "shipping_last_name" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isOneTime(element));
                    }
                }
            },
            "choice_state" : {
                required: isStateZipRequired
            },
            "zip" : {
                required: isStateZipRequired
            },
            "shipping_address_1" : {
                required: isShippingRequired,
            },
            "shipping_city" : {
                required: isShippingRequired,
            },
            "shipping_country" : {
                required: isShippingRequired,
            },
            "choice_ship_state" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isStateZipRequired(element));
                    }
                }
            },
            "shipping_zip" : {
                required: {
                    depends: function(element) {
                        return (isShippingRequired(element) && isStateZipRequired(element));
                    }
                }
            },
            "radio_station_mediaid" : {
                required: true,
                minlength: '2'
            },
            "recurrence_day" : {
              required: true,
            },
            "auto_draft_initials" : {
              required: true,
            },
            "wants_donation_product": {
              required: true,
            },
        },
        messages : {
            "phone" : {
                minlength: "Please enter a valid phone number."
            },
            "cc_token_val": {
                required: "<b>Your payment information contains the following errors:</b>"
            },
            "saved_payment_id": {
                required: "Please select a payment method."
            },
            "radio_station_mediaid" : {
                required: "This is required. If you listen on the radio and you don't see any stations listed above, click 'Find Your Station' to search for a station."
            },
            "auto_draft_initials": {
                required: "Your initials are required to authorize this recurring gift."
            },
        },
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids()) {
                return;
            }
            if ($(validator.errorList[0].element).attr('name') == 'cc_token_val') {
                var destination = $(validator.errorList[0].element).closest('form').find('.clover_wrapper');
                if (destination) {
                  scrollToIt(destination.offset());
                }
            }
            else {
                scrollToIt($(validator.errorList[0].element).offset());
            }
        },
    };

    $('.country_picker').on('change', function() {
        if ($(this).attr('id') != 'stationpicker_modal_country') {
            var section = $(this).closest('.form-section');
            section.find('.choice_state, .choice_ship_state, .zip_picker').each(function() {
                $(this).valid();
            });
        }
    });

}

function payment_validation() {
    if ($("#givingform").data("validator")) {
        $("#givingform").validate().destroy();
    }

    if ($('#givingform').hasClass('payment-monthly')) {
        tfl_validate.push(['#givingform', TFL_donate.monthly_validation]);
    }
    else if ($('#givingform').hasClass('payment-cc')) {
        tfl_validate.push(['#givingform', TFL_donate.cc_validation]);
    }
    else if ($('#givingform').hasClass('payment-paypal')) {
        tfl_validate.push(['#givingform', TFL_donate.paypal_validation]);
    }
}

function copy_address_setup() {
    $('.copy_picker').change(function(ev) {
        var checkbox = $(ev.target);
        var form = checkbox.closest('form');
        var shipping = form.find('.shipping-fields');
        // QAS address verification will ignore empty address fields, so we
        // empty the shipping address fields when hidden. We also save the
        // prior value so that we can restore it when we show the shipping address
        shipping.find('input, select').prop('disabled', checkbox.is(':checked'));
        shipping.toggle(!checkbox.is(':checked'));
    }).change();
}

function phone_input_setup() {
    // Set up forms to use phone number filter per country
    $(".phone_input").intlTelInput({
        utilsScript: "/static/js/responsive/lib/libphonenumber/utils.js",
        responsiveDropdown: true,
        preferredCountries: ["us", "ca"],
        separateDialCode: false,
        initialCountry: "us",
        nationalMode: false,
    });

    $(".phone_input").on('blur keyup change click', function() {
      // Format phone number after input.
      $(this).val($(this).intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL));

      var data = $(this).intlTelInput("getSelectedCountryData");
      var country = $(this).closest('.form-section').find('.country_picker');
      // Only change value and trigger change() event if different than current.
      if (country.val() != data['iso2'].toUpperCase()) {
          country.val(data['iso2'].toUpperCase()).change();
      }
    });
}

function country_state_setup() {
    $(document).on("change", ".country_picker", function(ev) {
        var picker = $(ev.target);
        if ($(picker).attr('id') != 'stationpicker_modal_country') {
            if ($(picker).val() != 'US') {
                $('#camessage').modal()
            }
            updateStateField(picker);
        }
    });
    $(".country_picker").each(function(i, v) { updateStateField($(v)); });
}

function updateStateField(country) {
    var showDropDown = $(country).val() == 'CA' || $(country).val() == 'US';
    var stateFields = $();
    if ($(country).attr('id').match(/ship/)) {
        stateFields = country.closest('.form-section').find('.choice_ship_state');
    }
    else {
        stateFields = country.closest('.form-section').find('.choice_state');
    }
    if (showDropDown) {
        country.closest('.form-section').find('.us-req').removeClass('hidden');
    }
    else {
        country.closest('.form-section').find('.us-req').addClass('hidden');
    }
    toggleStateDropdown(showDropDown, stateFields);
    if (showDropDown) {
        stateFields.find('option').each(function() {
            if ($(this).data('country') && $(this).data('country') != country.val()) {
                $(this).addClass('hidden');
            }
            else {
                $(this).removeClass('hidden');
            }
        });
        if (stateFields.find(':selected').hasClass('hidden')) {
            stateFields.prop('selectedIndex', 0);
        }
    }
}

function toggleStateDropdown(showDropdown, stateFields) {
    var stateInput = stateFields.filter('input');
    var stateDropdown = stateFields.filter('select');

    var hideThis, showThis;
    if (showDropdown) {
        hideThis = stateInput;
        showThis = stateDropdown;
    }
    else {
        hideThis = stateDropdown;
        showThis = stateInput;
    }
    if (showThis) {
        showThis.removeClass('hidden').prop('disabled', false);
    }
    if (hideThis) {
        hideThis.addClass('hidden').prop('disabled', true);
    }
}

function setupResourceRadioButtons() {
    // on page load, for any resources block thats not checked "yes", *hide* the options
    $(".radio.Resources").each(function() {
        var jqResources = $(this);
        var jqYes = jqResources.find("input[value!='0']");
        if(!jqYes.prop("checked")) {
            jqResources.find(".available-formats").hide();
        }
    });

    // after that, *show* the options every time the corresponding radio changes to "yes", and *hide* it otherwise
    $("body").on("change", '.radio.Resources', function(inEvent) {
        var jqTarget = $(inEvent.target);
        var jqOptions = $(inEvent.currentTarget).find(".available-formats");
        if (jqTarget.attr("type") == "radio") {
            if (jqTarget.attr("value") != "0") {
                jqOptions.show();
                $(jqOptions).find(".selected").click();
                return;
            }
            jqOptions.hide();
        }
    });
}

function setUpGiftEffects() {
  let body = $("body");

  body.on("change", ".wants_donation_product", function() {
    if ($(this).is(":checked") && $(this).val() === "2") {
      // Send resource as gift
      $(".js-is_gift").val("true");
      // Open shipping box if needed
      let sameAsBilling = $(".shipping_address_change_link, .js-copy_address");
      if (sameAsBilling.is(":checked")) {
        sameAsBilling.click();
      }
      // Show gift note
      $(".js-note_to_recipient__wrapper").removeClass("hide");
      // Disable monthly giving
      let monthlyCheckbox = $(".js-give_monthly");
      monthlyCheckbox.prop("disabled", true);
      monthlyCheckbox.parent("label").addClass("muted-text");
      $(".js-show_when_gifting").removeClass("hidden");

    } else {
      // Don't send resource as a gift
      $(".js-is_gift").val("false");
      // Hide gift note
      $(".js-note_to_recipient__wrapper").addClass("hide");
      // Enable monthly giving (if other, unrelated conditions are met)
      _conditionallyEnableMonthly();
      $(".js-show_when_gifting").addClass("hidden");
    }
  });

  // Resource format
  body.on("resourceSelected", ".available-formats", function(event){
    // If the premium is to be gifted but isn't shippable, show an appropriate warning.
    let shippableResource = $(event.target).children("input.hide[data-shippable=1]");
    let shippable = shippableResource.length === 1;
    let gifting = $(".wants_donation_product.not-monthly:checked").val() === "2";

    if (gifting && !shippable) {
      // Show warning about digital gifts not really supported
      $(".js-digital_gift").removeClass("hide");
      // Turn off note and hidden gifting flag
      $(".js-is_gift").val("false");
      $(".js-note_to_recipient__wrapper").addClass("hide");
    } else {
      // In all other cases, hide the warning about digital gifts
      $(".js-digital_gift").addClass("hide");
    }

    if (gifting && shippable) {
      // Make sure the gifting is enabled
      $(".js-is_gift").val("true");
      $(".js-note_to_recipient__wrapper").removeClass("hide");
    }
  });

  body.on("change", ".js-give_monthly", function(){
    // Gifting a resource is not supported for monthly donations
    let checked = $(this).is(":checked");
    $(".wants_donation_product[value=2]").prop("disabled", checked);

    let label = $("label.js-wants_product_choice_2");
    if (checked) {
      label.addClass("disabled");
      $(".js-show_when_recurring").removeClass("hidden");
    } else {
      label.removeClass("disabled");
      $(".js-show_when_recurring").addClass("hidden");
    }
  });
}

function scrollToIt(destination) {
    if (destination) {
        var myTop = destination.top - 100;
        if (myTop) {
            $('html').animate({scrollTop: myTop}, 'slow');
        }
    }
}
